import Main from './QuestionnairesMain'
import Reply from './QuestionnairesReply'
import DponetReply from './DponetQuestionnairesReply'
import SuppliersReply from './SuppliersQuestionnairesReply'

export default {
  Main,
  Reply,
  DponetReply,
  SuppliersReply,
}
